import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  HasApplicantFiledTR,
  RulesetResult,
  IsBusinessEstablishedMoreThan,
  IsExpressLoan,
  IsBetweenJanAndMidFeb,
  IsBetweenMidAprilMidMay,
  IsForProfit,
  IsBetweenMidAugMidOct,
  IsBetweenMidMayMidAug,
} from '../rules';
import IsBetweenMidFebMidApril from '../rules/IsBetweenMidFebMidApril';

class TR4YearsAgoRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isExpress = IsExpressLoan.evaluate(data);
    const hasApplicantFiledTR = HasApplicantFiledTR.evaluate(data);
    const isForProfit = IsForProfit.evaluate(data);
    const isBetweenJanAndMidApril = [
      IsBetweenJanAndMidFeb,
      IsBetweenMidFebMidApril,
    ].some((Is) => Is.evaluate(data));
    const isBetweenMidAprilAndMidOct = [
      IsBetweenMidAprilMidMay,
      IsBetweenMidMayMidAug,
      IsBetweenMidAugMidOct,
    ].some((Is) => Is.evaluate(data));
    const isBusinessEstablishedMoreThan4YearsAgo =
      IsBusinessEstablishedMoreThan.setYears(4).evaluate(data);

    // If Not Express:
    // - Between Jan and Mid April && Established More Than 4 Years Ago? REQUIRED : OPTIONAL
    // - Between Mid April and Mid Oct?: Optional
    // - Else Hidden
    // If Not For Profit and Not Filed TR In The Past: Hidden

    // Express Loan always hide this field (03/11/2025)
    if (isExpress) return RulesetResult.HIDDEN;
    if (!isForProfit && !hasApplicantFiledTR) return RulesetResult.HIDDEN;

    // If Not Express:
    // - Between Jan and Mid April && Established More Than 4 Years Ago? REQUIRED : OPTIONAL
    if (isBetweenJanAndMidApril) {
      return isBusinessEstablishedMoreThan4YearsAgo
        ? RulesetResult.REQUIRED
        : RulesetResult.OPTIONAL;
    }

    // - Between Mid April and Mid Oct?: Optional
    if (isBetweenMidAprilAndMidOct) {
      return RulesetResult.OPTIONAL;
    }

    return RulesetResult.HIDDEN;
  };
}

export default new TR4YearsAgoRuleset();
